module.exports = __webpack_public_path__ + "National2Web-Light.woff?f40c8ddb7eaaac08426d13392da87b89";